export function groupBy(array, field) {
  return array.reduce((acc, item) => {
    if (!acc[item[field]]) {
      acc[item[field]] = [];
    }
    acc[item[field]].push(item);
    return acc;
  }, {});
}

export function splitArrayToChunks(array, options) {
  const chunks = typeof options === 'number' ? options : options.chunks;
  const chunkSize = options?.chunkSize || 0;
  if (chunks === 0) {
    return [];
  }
  const size = chunkSize || Math.ceil(array.length / chunks);

  return array.reduce((acc, value, index) => {
    const currentChunk = Math.floor(index / size);

    if (!acc[currentChunk]) {
      acc[currentChunk] = [];
    }

    acc[currentChunk].push(value);
    return acc;
  }, []);
}

export function arrayMove(arr, oldIndex, newIndex) {
  if (!arr) {
    return arr;
  }
  const clonedArray = [...arr];
  const elementToMove = arr[oldIndex];
  clonedArray.splice(oldIndex, 1);
  clonedArray.splice(newIndex, 0, elementToMove);
  return clonedArray;
}

export function refToArray(ref, additionalDataFn = () => null) {
  let docs;
  if (Array.isArray(ref.docs)) {
    ({ docs } = ref);
  } else if (typeof ref._docs === 'function') {
    docs = ref._docs();
  } else {
    docs = [];
  }
  return docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
    ...additionalDataFn(doc.data()),
  }));
}
